import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

declare let DD_RUM: any;

// Init Datadog RUM
if (environment.datadog && typeof DD_RUM !== 'undefined') {
  const ddConfig = environment.datadog;

  DD_RUM.init({
    applicationId: ddConfig.applicationId,
    clientToken: ddConfig.clientToken,
    site: ddConfig.site || 'datadoghq.eu',
    service: 'exchange-client',
    env: ddConfig.env,
    version: ddConfig.version || 'local',
    sessionSampleRate: ddConfig.sessionSampleRate || 100,
    sessionReplaySampleRate: ddConfig.sessionReplaySampleRate || 20,
    trackUserInteractions: true,
    trackFrustrations: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      { match: environment.exchangeApi.url, propagatorTypes: ['datadog', 'tracecontext'] },
    ],
  });

  if (ddConfig.sessionReplaySampleRate > 0) {
    DD_RUM.startSessionReplayRecording();
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
